import { configureStore } from '@reduxjs/toolkit';
import reducer from './Counter';

export default configureStore({
    reducer: {
        counter: reducer
    }
});